import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { RcFile } from "antd/es/upload";
import { CreatePropertyType, CreateContactType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const uploadCompanyImage = async ({
  owner_id,
  image,
  image_type,
}: {
  owner_id: string;
  image: RcFile | File;
  image_type: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  formData.append("image", image);
  formData.append("image_type", image_type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}uploadUserImage`, formData, config);
};

export const createProperty = (
  payload: CreatePropertyType
): Promise<AxiosResponse<CreatePropertyType>> => {
  return axios.post(`${baseURL}createProperty`, payload);
};

export const changePropertyStatus = (
  id: string,
  payload: {
    status: string;
  }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}changePropertyStatus/${id}`, payload);
};

export const deleteProperty = (
  propertyIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteProperty`, { data: propertyIds });
};

export const updatePropertyById = (
  id: string,
  payload: CreatePropertyType
): Promise<AxiosResponse<CreatePropertyType>> => {
  return axios.patch(`${baseURL}updatePropertyById/${id}`, payload);
};

export const changePropertyManager = (payload: {
  property_id: string;
  manager_id: string;
}): Promise<AxiosResponse<CreatePropertyType>> => {
  return axios.patch(`${baseURL}changePropertyManager`, payload);
};

export const createClientContact = (
  payload: CreateContactType
): Promise<AxiosResponse<CreateContactType>> => {
  return axios.post(`${baseURL}createClientContact`, payload);
};

export const updateClientContactById = (
  id: string,
  payload: CreateContactType
): Promise<AxiosResponse<CreateContactType>> => {
  return axios.patch(`${baseURL}updateClientContactById/${id}`, payload);
};

export const deleteClientContact = (
  contactId: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteClientContact/${contactId}`);
};
